import { FC, useState } from "react";
import useI18n from "../../../../../hooks/useTranslations";
import Button from "../../../../ui/Button";
import ModalDialog from "../../../../ui/ModalDialog";
import RailCurveForm from "./RailCurveForm";

interface CreateRailCurveModalDialogButtonProps {
  onCreated?: (id: string) => void;
}

const CreateRailCurveModalDialogButton: FC<CreateRailCurveModalDialogButtonProps> = ({ onCreated }) => {
  const i18n = useI18n();
  const [showNewItemDialog, setShowNewItemDialog] = useState(false);

  return (
    <>
      <Button buttonProps={{ onClick: () => setShowNewItemDialog(true) }}>{i18n.translation.common.createNew}</Button>
      {showNewItemDialog && (
        <ModalDialog onClose={() => setShowNewItemDialog(false)} title={i18n.translation.railCurves.new}>
          <RailCurveForm onClose={() => setShowNewItemDialog(false)} onCreated={onCreated} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateRailCurveModalDialogButton;
